import { FormEvent } from 'react';
import type { Participant } from '../../types/participant';
import { formatCPF, formatPhone, formatCEP } from '../../types/api';
import { Form, FormField, FormLabel, Button } from '../ui';
import { FormInput, FormCpfCnpj, FormPhone, FormMail, FormCEP } from '../ui/FormControls';

interface ParticipantFormProps {
  participant: Participant | null;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
}

function ParticipantForm({ participant, onSubmit, isLoading, onClose }: ParticipantFormProps) {
  return (
    <Form onSubmit={onSubmit}>
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-6 mb-6">
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4 flex items-center">
          <span className="bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 p-1.5 rounded-lg mr-2">
            Pessoal
          </span>
          Dados Pessoais
        </h3>

        <FormField>
          <FormLabel htmlFor="cpf" required>
            CPF
          </FormLabel>
          <FormCpfCnpj
            id="cpf"
            name="cpf"
            type="cpf"
            value={participant?.cpf ? formatCPF(participant.cpf) : ''}
            onChange={() => {}}
            required
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="full_name" required>
            Nome Completo
          </FormLabel>
          <FormInput
            id="full_name"
            name="full_name"
            defaultValue={participant?.full_name}
            required
          />
        </FormField>
      </div>

      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-6 mb-6">
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4 flex items-center">
          <span className="bg-green-100 dark:bg-green-900 text-green-700 dark:text-green-300 p-1.5 rounded-lg mr-2">
            Contato
          </span>
          Informações de Contato
        </h3>

        <div className="grid grid-cols-2 gap-4">
          <FormField>
            <FormLabel htmlFor="phone">Telefone</FormLabel>
            <FormPhone
              id="phone"
              name="phone"
              value={participant?.phone ? formatPhone(participant.phone) : ''}
              onChange={() => {}}
            />
          </FormField>

          <FormField>
            <FormLabel htmlFor="email">Email</FormLabel>
            <FormMail
              id="email"
              name="email"
              value={participant?.email || ''}
              onChange={() => {}}
            />
          </FormField>
        </div>
      </div>

      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-6">
        <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100 mb-4 flex items-center">
          <span className="bg-purple-100 dark:bg-purple-900 text-purple-700 dark:text-purple-300 p-1.5 rounded-lg mr-2">
            Endereço
          </span>
          Informações de Endereço
        </h3>

        <FormField>
          <FormLabel htmlFor="address">Endereço</FormLabel>
          <FormInput id="address" name="address" defaultValue={participant?.address} />
        </FormField>

        <div className="grid grid-cols-2 gap-4">
          <FormField>
            <FormLabel htmlFor="city">Cidade</FormLabel>
            <FormInput id="city" name="city" defaultValue={participant?.city} />
          </FormField>

          <FormField>
            <FormLabel htmlFor="postal_code">CEP</FormLabel>
            <FormCEP
              id="postal_code"
              name="postal_code"
              value={participant?.postal_code ? formatCEP(participant.postal_code) : ''}
              onChange={() => {}}
            />
          </FormField>
        </div>
      </div>

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button type="submit" isLoading={isLoading} className="sm:col-start-2">
          {participant ? 'Salvar' : 'Criar'}
        </Button>
        <Button type="button" variant="secondary" onClick={onClose} className="sm:col-start-1">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default ParticipantForm;
